import React, { useState } from "react";
import { Typography, Space, Segmented } from "antd";
import { ApiOutlined, BookOutlined } from "@ant-design/icons";
import { PartnerApiDocs } from "../components/admin/bot/PartnerApiDocs";
import { PartnerApiGlossary } from "../components/admin/bot/PartnerApiGlossary";

const { Title, Paragraph } = Typography;

type PublicView = "docs" | "glossary";

/** Public, no-auth page so the partner API docs can be shared as a link. */
const PartnerApiDocsPage: React.FC = () => {
  const [view, setView] = useState<PublicView>("docs");

  return (
    <div
      style={{
        padding: "24px 16px 48px",
        background: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <div style={{ maxWidth: 920, margin: "0 auto 16px" }}>
        <Space align="center" style={{ marginBottom: 8 }} size="middle">
          <img
            src="/logo_black.png"
            alt="eFreight Forwarding"
            style={{ height: 36, width: "auto", display: "block" }}
          />
          <Title level={3} style={{ margin: 0 }}>
            Partner API
          </Title>
        </Space>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>
          Public reference for the read-only dashboard data API. Ask an eFreight
          admin for a partner API key (<code>effp_…</code>).
        </Paragraph>
        <Segmented
          value={view}
          onChange={(value) => setView(value as PublicView)}
          options={[
            {
              label: "API docs",
              value: "docs",
              icon: <ApiOutlined />,
            },
            {
              label: "Glossary",
              value: "glossary",
              icon: <BookOutlined />,
            },
          ]}
        />
      </div>

      {view === "docs" && <PartnerApiDocs publicPage />}
      {view === "glossary" && <PartnerApiGlossary publicPage />}
    </div>
  );
};

export default PartnerApiDocsPage;
